"use client";

import { cardPaymentMethodSchema } from "../../../../lib/types/schema/subscription/cardPaymentMethodSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyPaymentMethod } from "./keyPaymentMethod";

export const useRequestPaymentMethod = ({
  ...props
}: UseRequestQueryProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: cardPaymentMethodSchema,
      urlBackendPath: "/payments/method",
    },
    queryKey: keyPaymentMethod(),
  }),
});
